import { Box, Icon } from "@outschool/backpack";
import { CategoryPage } from "@outschool/gql-backend-generated";
import { faHome } from "@outschool/icons";
import { useTranslation } from "@outschool/localization";
import { onlineClassesPath } from "@outschool/routes";
import { useLinkComponent } from "@outschool/ui-utils";
import React from "react";

type CategoryBreadcrumbsProps = {
  ancestors: CategoryPage[] | null;
  currentCategoryName: string;
  categorySlug: string;
  treatment?: boolean;
  pathname: string;
};

const CategoryBreadcrumbs = ({
  ancestors,
  currentCategoryName,
  categorySlug,
  treatment = false,
  pathname
}: CategoryBreadcrumbsProps) => {
  const Link = useLinkComponent();
  const { t } = useTranslation(
    "client\\components\\categories\\categoryBreadcrumbs"
  );
  const isCatalogHub = pathname === "/online-classes";

  const startIndex = treatment ? 1 : 0;
  // if there are no ancestors it's value is null, which doesn't .map
  ancestors = ancestors || [];
  // Breadcrumb navigation CSS recipe from:
  // https://developer.mozilla.org/en-US/docs/Web/CSS/Layout_cookbook/Breadcrumb_Navigation
  return (
    <Box
      sx={{
        fontSize: 14,
        color: "grey.900",

        ul: {
          display: "flex",
          marginY: 0,
          flexWrap: "wrap"
        },

        li: {
          listStyleType: "none",

          a: {
            whiteSpace: "nowrap"
          }
        },

        "li:not(:last-child)::after": {
          content: '"/"',
          paddingX: "8px"
        }
      }}
    >
      <nav aria-label={t("Breadcrumb")}>
        <ul>
          {treatment && (
            <li>
              <Link
                reloadDocument
                to="/"
                trackingName="category_breadcrumbs"
                trackingUniqueId="home"
                sharedProperties={{
                  breadcrumbIdx: 0
                }}
              >
                <Icon icon={faHome} />
              </Link>
            </li>
          )}
          {ancestors.map((ancestor, index) => (
            // this works if ancestors == [], simply renders nothing here
            <li key={ancestor.slug}>
              <Link
                to={onlineClassesPath(ancestor.slug, ancestor.basePath)}
                trackingName="category_breadcrumbs"
                trackingUniqueId={ancestor.slug}
                sharedProperties={{
                  categoryPage: categorySlug,
                  breadcrumbIdx: startIndex + 1 + index
                }}
              >
                {ancestor.nameTitleCased[0] +
                  ancestor.nameSentenceCased.substring(1)}
              </Link>
            </li>
          ))}
          {!isCatalogHub && (
            <li>
              <span aria-current="page">{currentCategoryName}</span>
            </li>
          )}
        </ul>
      </nav>
    </Box>
  );
};

export default CategoryBreadcrumbs;
